<template>
    <div class="mx-auto">
        <b-row class="mb-0">
            <b>Pesquisa pelo número da CDA:</b>
            <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Utilize esse campo para pesquisar os registros de protesto e ajuizamento de uma determinada CDA.'">
            </i>
        </b-row>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o número da CDA:"
                        label-for="numeroDivida"
                        class="text-label">
                    <b-form-input
                            ref="numeroDivida"
                            type="text"
                            id="numeroDivida"
                            v-model="filtros.numeroDivida"
                            v-mask="['##########']"
                            description="Somente os números"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b>Pesquisa pelo número da Execução Fiscal:</b>
            <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Utilize esse campo para pesquisar uma determinada execução fiscal ajuizada e suas respectivas CDAs.'">
            </i>
        </b-row>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o número CNJ:"
                        label-for="cnj"
                        class="text-label">
                    <b-form-input
                            type="text"
                            id="cnj"
                            v-model="filtros.cnj"
                            v-mask="['#######-##.####.#.##.####']"
                            description="Somente os números"
                            @change="validarCnj"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b>Pesquisa por Devedor:</b>
            <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Utilize esse campo para pesquisar os registros de protesto e ajuizamento de CDAs de um determinado devedor.'">
            </i>
        </b-row>
        <b-row>
            <b-col md="2">
                <b-form-group
                        label="Informe o CPF / CNPJ / Raiz CNPJ:"
                        label-for="cpf"
                        class="text-label">
                    <b-form-input
                            type="text"
                            ref="numDocumento"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="filtros.cpfCnpj"
                            v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                            @change="buscarDevedor"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label" >
                    <vue-suggestion :items="devedores"
                                    v-model="filtros.nomeDevedor"
                                    :setLabel="setLabel"
                                    :itemTemplate="itemTemplate"
                                    :inputClasses="'form-control'"
                                    :minLen="3"
                                    @changed="inputChange"
                                    @blur="inputBlur"
                                    @selected="itemSelected"
                                    @enter="acaoEnter">
                    </vue-suggestion>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mb-0">
            <b>Pesquisa CDAs protestadas/ajuizadas num período determinado:</b>
            <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
               v-b-popover.hover.top="'Utilize esse campo para pesquisar os registros de protesto e ajuizamento de CDAs realizados num determinado período e de devedores diversos.'">
            </i>
        </b-row>
        <b-row>
            <b-col md="2">
                <label>
                    Informe a data de início:
                </label>
                <b-input v-model="filtros.dataInicio" type="date" placeholder></b-input>
            </b-col>
            <b-col md="2">
                <label>
                    Informe a data de fim:
                </label>
                <b-input v-model="filtros.dataFinal" type="date" placeholder></b-input>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import itemTemplate from './item-template.vue';

    export default {
        props: ['filtros'],
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                devedores: [],
                itemTemplate,
            }
        },
        methods: {
            itemSelected (item) {
                this.filtros.nomeDevedor = item.nome;
                this.filtros.cpfCnpj = item.cpfCnpjString;
            },
            inputBlur (item) {
                this.filtros.nomeDevedor = {nome: item};
            },
            setLabel (item) {
                return item.nome;
            },
            inputChange (text) {
                if(text != null && text.length >= 3) {
                    let devedor = {
                        nome: text
                    };

                    axios.post(`${this.urlApi}/v1/consultarCdas/listarDevedorPorNome`, devedor, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.devedores = response.data;
                    })
                }
            },
            async buscarDevedor() {
                if(this.filtros.cpfCnpj != null && this.filtros.cpfCnpj.length > 0) {
                    this.$store.commit("setMessages", {});
                    this.filtros.nomeDevedor = {id: 0, nome: ''};

                    if(this.filtros.cpfCnpj.length == 10) {
                        return;
                    } else if(this.filtros.cpfCnpj.length <= 14 && !this.validarCpf(this.filtros.cpfCnpj, true)) {
                        this.exibirErro('CPF inválido.');
                        return;
                    } else if(this.filtros.cpfCnpj.length > 14 && !this.validarCNPJAlfanumerico(this.filtros.cpfCnpj, true)) {
                        this.exibirErro('CNPJ inválido.');
                        return;
                    }

                    let devedor = {
                        cpfCnpj: this.filtros.cpfCnpj
                    };

                    axios.post(`${this.urlApi}/v1/consultarCdas/obterNomeDevedor`, devedor, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        if(response.data != null && response.data != "") {
                            this.filtros.nomeDevedor = {id: 0, nome: response.data};
                        }
                    }).finally(() => {
                    });
                }
            },
            validarCnj() {
                if(this.filtros.cnj != null && this.filtros.cnj != "" && (this.filtros.cnj.length < 25 || !this.validaCnj(this.filtros.cnj))) {
                    this.exibirErro('CNJ inválido.');
                }
            },
            acaoEnter() {
                document.getElementById("btnProxima").click();
            },
            focusNumeroDivida() {
                setTimeout(()=>{
                    this.$refs['numeroDivida'].$el.focus();
                }, 500);
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.focusNumeroDivida();

            window.addEventListener("keypress", function(e) {
                if(e.key == 'Enter') {
                    document.getElementById("btnProxima").click();
                }
            });
        }
    }
</script>